module.exports = __webpack_public_path__ + "static/media/icon-local.3e4b77da.svg";